import { render, staticRenderFns } from "./TotemVSDebility.vue?vue&type=template&id=3b3ca9c0"
import script from "./TotemVSDebility.vue?vue&type=script&lang=js"
export * from "./TotemVSDebility.vue?vue&type=script&lang=js"
import style0 from "./TotemVSDebility.vue?vue&type=style&index=0&id=3b3ca9c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports